// src/userMap.ts
// Active trial device whitelist with name + token
// Remove or change token to instantly expire a link

const userMap: {
  [key: string]: { name: string; token: string };
} = {

  // 12-pin solar - Single Phase

  ENSN001: { name: 'Jyoti Singh', token: '1' },
  ENSN002: { name: '-', token: '1' },
  ENSN003: { name: 'Santram Ahirwar', token: '1' },
  ENSN004: { name: 'Testing', token: '1' },
  ENSN005: { name: 'Testing', token: '1' },
  ENSN006: { name: 'Testing', token: '1' },
  ENSN007: { name: 'Testing', token: '1' },


  
  ENTN001: { name: 'Testing', token: '1' },
  ENTN002: { name: 'Testing', token: '1' },
  ENTN003: { name: 'Testing', token: '1' },
  ENTN004: { name: 'Testing', token: '1' },
  ENTN005: { name: 'Testing', token: '1' },
  ENTN006: { name: 'Testing', token: '1' },
  ENTN007: { name: 'Testing', token: '1' },
  ENTN008: { name: 'Testing', token: '1' },
  ENTN009: { name: 'Testing', token: '1' },
  ENTN010: { name: 'Testing', token: '1' },
  ENTN011: { name: 'Testing', token: '1' },
  ENTN012: { name: 'Testing', token: '1' },
  ENTN013: { name: 'Testing', token: '1' },
  ENTN014: { name: 'Testing', token: '1' },
  ENTN015: { name: 'Testing', token: '1' },
  ENTN016: { name: 'Testing', token: '1' },
  ENTN017: { name: 'Testing', token: '1' },
  ENTN018: { name: 'Testing', token: '1' },
  ENTN019: { name: 'Testing', token: '1' },
  ENTN020: { name: 'Testing', token: '1' },


  // 6-pin non-solar - Single Phase

  ENSA001: { name: 'To Your Dashboard', token: 'xy' },
  ENSA002: { name: 'To Your Dashboard', token: 'xy' },
  ENSA003: { name: 'To Your Dashboard', token: 'xy' },

    // 6-pin non-solar - Triple Phase

  ENTA001: { name: '—', token: '1' },
  ENTA002: { name: '—', token: '1' },

};

export default userMap;
